/*
 *
 * ImportDivisionsContainer constants
 *
 */

export const SAVE_TEMPLATE_WATCHER =
  "app/OrganizationPage/SAVE_TEMPLATE_WATCHER"
export const SAVE_TEMPLATE_SUCCESS =
  "app/OrganizationPage/SAVE_TEMPLATE_SUCCESS"
export const SAVE_TEMPLATE_FAILED = "app/OrganizationPage/SAVE_TEMPLATE_FAILED"
export const SAVE_TEMPLATE_PROGRESS =
  "app/OrganizationPage/SAVE_TEMPLATE_PROGRESS"
export const CLOSE_IMPORT = "app/OrganizationPage/CLOSE_IMPORT"

export const UPLOAD_TEMPLATE_W =
  "app/ImportDivisionsContainer/UPLOAD_TEMPLATE_W"

export const GET_DIVISIONS_SUMMARY_WATCHER =
  "app/ImportDivisionsContainer/GET_DIVISIONS_SUMMARY_WATCHER"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/ImportDivisionsContainer/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/ImportDivisionsContainer/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED =
  "app/ImportDivisionsContainer/UPLOAD_TEMPLATE_FAILED"
